import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {

  constructor() {
  }

  // This function is to show the content in diferent pages
  exportAsExcelFile(json: { [sheetName: string]: any }, fileName: string, title?: string): void {
    const workbook = XLSX.utils.book_new();
    for (const data in json) {
      if (json.hasOwnProperty(data)) {
        let jsonToSheetData: XLSX.WorkSheet;
        if (title) {
          jsonToSheetData = {'!rows': [{hpx: 30}]};
          jsonToSheetData = XLSX.utils.sheet_add_json(jsonToSheetData, json[data], {origin: 'A3'});
          jsonToSheetData['!merges'] = [{
            s: {c: 0, r: 0}, e:
              {c: (json[data].length ? (Object.keys(json[data][0]).length - 1) : 5), r: 0}
          }];
          jsonToSheetData['A1'] = {
            t: 's', v: title
          };
        } else {
          jsonToSheetData = XLSX.utils.json_to_sheet(json[data]);
        }
        jsonToSheetData['!cols'] = [];
        if (json[data].length) {
          for (let i = 0; i < Object.keys(json[data][0]).length; i++) {
            jsonToSheetData['!cols'].push({wpx: 85});
          }
        }
        XLSX.utils.book_append_sheet(workbook, jsonToSheetData, data);
      }
    }
    XLSX.writeFile(workbook, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // This function is to show the content in same page
  exportAsExcelInOneSheet(json: { [sheetName: string]: any }, fileName: string, title?: string): void {
    const workbook = XLSX.utils.book_new();
    let jsonToSheetData: XLSX.WorkSheet;

    if (title) {
      jsonToSheetData = {'!rows': [{hpx: 18}]};
      jsonToSheetData['A1'] = {
        t: 's', v: title
      };
      jsonToSheetData['!merges'] = [{
        s: {c: 0, r: 0}, e:
          {c: (json[Object.keys(json)[0]].length ? (Object.keys(json[Object.keys(json)[0]][0]).length - 1) : 5), r: 0}
      }];
    }

    let indexOfRows = (title ? 2 : 0);
    for (const data in json) {
      if (json.hasOwnProperty(data)) {
        indexOfRows++;
        if (Object.keys(json).length > 1) {
          jsonToSheetData = XLSX.utils.sheet_add_json(jsonToSheetData, json[data], {origin: `A${indexOfRows + 1}`});
          jsonToSheetData[`A${indexOfRows}`] = {
            t: 's', v: data
          };
          indexOfRows++;
        } else {
          jsonToSheetData = XLSX.utils.sheet_add_json(jsonToSheetData, json[data], {origin: `A${indexOfRows}`});
        }

        indexOfRows = indexOfRows + json[data].length + 1;
      }
    }
    jsonToSheetData['!cols'] = [];
    for (let i = 0; i < indexOfRows; i++) {
      jsonToSheetData['!cols'].push({wpx: 85});
    }

    XLSX.utils.book_append_sheet(workbook, jsonToSheetData, 'Hoja 1');

    XLSX.writeFile(workbook, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}
